import { ReactNode } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';

import { wacToken } from '@/libraries/design/foundations';

const tabVerticalWrapper = css({
	display: 'flex',
	flexDirection: 'column',
});
const tabTextWrapper = css({
	display: 'flex',
	alignItems: 'center',

	[media.below.sm]: {
		paddingBlock: 12,
		paddingInlineStart: 2,
		paddingInlineEnd: 4,
	},
	[media.above.sm]: {
		paddingBlock: 16,
		paddingInlineStart: 4,
		paddingInlineEnd: 8,
	},

	':hover': {
		color: wacToken('color.extended.blue700'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		p: {
			color: wacToken('color.extended.blue700'),
		},
	},
});

const selectedTabStyle = css({
	color: wacToken('color.extended.blue700'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& p.h4': {
		color: wacToken('color.extended.blue700'),
	},
});

const titleStyle = css({
	marginBlock: 0,

	[media.below.sm]: {
		marginInlineStart: 8,
	},
	[media.above.sm]: {
		marginInlineStart: 16,
	},
});

const lozengeStyle = css({
	marginInlineStart: 8,
	borderRadius: 3,
	backgroundColor: wacToken('color.extended.blue100'),
	color: wacToken('color.extended.blue800'),
	paddingInline: 4,
	textTransform: 'uppercase',
	fontSize: '0.6875rem',
	lineHeight: '1rem',
	fontWeight: 500,
	verticalAlign: 'middle',
});

const underline = css({
	display: 'flex',
	height: 4,
	borderRadius: 2,
});

const selectedUnderline = css({
	backgroundColor: wacToken('color.extended.blue700'),
});

export type IconTabsProps = {
	isSelected?: boolean;
	icon: ReactNode;
	title: string;
	lozenge?: string;
};

export const IconTab = ({ isSelected, icon, title, lozenge }: IconTabsProps) => {
	return (
		<div css={tabVerticalWrapper}>
			<div css={[tabTextWrapper, isSelected && selectedTabStyle]}>
				{icon}
				<p className="h4" css={titleStyle}>
					{title}
					{lozenge && <span css={lozengeStyle}>{lozenge}</span>}
				</p>
			</div>
			<div css={[underline, isSelected && selectedUnderline]} />
		</div>
	);
};
